module.exports = __webpack_public_path__ + "static/media/img-guadalajara.4ca258ea.jpg";